export enum TransactionTypeEnum {
    Preauth = 1,
    Capture = 2,
    CustomerTip = 3,
    RiderTransferFromXpressWallet = 4,
    RiderEarning = 5,
    Refund = 6,
    TopUpWallet = 7,
    PayOut = 8,
    RiderCommission = 9,
    DailyServiceFee = 10,
    PayOutPending = 11,
    PayOutFee = 12,
    PayOutRestore = 13,
    CancellationFee = 14,
    WaitingFee = 15,
    PayOutFeeRestore = 16,
    WaitingFeeRiderEarning = 17,
    CancellationFeeRiderEarning = 18,
    WithholdingTax = 19,
    ReferralEarning = 20,
    PrizeMoney = 21,
    RiderServiceFee = 22,
    CashRiderEarning = 23,
    RiderTip = 24,
    XpressIncentive = 25,
    RiderTransferToCashWallet = 26,
    PayOutToPaymentCard = 27,
    TopUpFromPaymentCard = 28,
    AdjustWalletBalance = 29,
    Void = 30,
    OnlineTimeIncentive = 31,
    RxpDailyDeduction = 32,
    RxpGuaranteePay = 33,
    CancellationFeeForDeclinedRiderSchedule = 34,
    RiderPriorityBonus = 35,
    BoundaryFee = 36,
    BoundaryProcessingFee = 37,
    Promo = 38,
    CebuanaTopUpRequest = 39,
    CebuanaTopUpCallback = 40,
    AdminAdjustmentNineNine15KTopUp = 85,
    AdminAdjustment4KTopUp = 86,
    GeneralAdjustment = 87,
}
